module.exports = __webpack_public_path__ + "img/caribou-hunting-cabin.f32139ba.webp";